import React from 'react';
import styled from 'styled-components';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import useChangeTabs from '../../../hooks/useChangeTabs';
import useBottomNavValue from '../../../hooks/useAccountNavValue';
import { colors } from '../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import useRuntimeVariable from '../../../../../../hooks/runtime/useRuntimeVariable';
import AccountViews from '../../../../../AccountGetsMarried/constants/AccountViews';
import { useBottomNavHeight } from '~/components/SolvPatternLibrary/AccountNav/hooks/useBottomNavHeight';

const BottomNav = styled(({ height, ...rest }) => <BottomNavigation {...rest} />).withConfig({ componentId: 'sc-fbi8a7-0' })`
  bottom: 0;
  width: 100%;
  z-index: 1102; // Ensures Bottom Nav is above Sticky Footer
  position: fixed;
  height: ${(props) => props.height};
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.12);

  && .root {
    transition: color 200ms ease;
    align-items: baseline;
    min-width: 40px;
  }

  && .selected .label {
    color: ${colors.grey600};
    font-size: ${fontSize.small};
    font-family: ${fontFamily.medium};
  }

  && .selected .wrapper svg {
    color: ${colors.crunchBerry};
  }

  && .label {
    font-size: ${fontSize.small};
    font-family: ${fontFamily.book};
    color: ${colors.grayMatter};
    letter-spacing: 0.55px;
    line-height: 16px;
    padding-top: 4px;
  }

  && .wrapper svg {
    color: ${colors.lightText};
  }
`;

type Props = {
  viewName?: string;
  children: React.ReactElement[];
};

export const bottomNavId = 'bottom-nav';

const StuckToTheBottom = (props: Props) => {
  const { viewName, children } = props;
  const bottomNavHeight = useBottomNavHeight();

  const value = useBottomNavValue(viewName);
  const chatNavValue = useBottomNavValue(AccountViews.Chat);
  const onChangeCallback = useChangeTabs();

  const [showConciergeChat] = useRuntimeVariable('showConciergeChat', false);

  return (
    <BottomNav
      height={bottomNavHeight}
      id={bottomNavId}
      onChange={onChangeCallback}
      showLabels
      value={showConciergeChat ? chatNavValue : value}
    >
      {children}
    </BottomNav>
  );
};

export default StuckToTheBottom;
